import { Link } from "react-router-dom";

export function DesktopNav({ links, pathname }) {
  return (
    <nav className="hidden lg:flex items-center gap-7">
      {links.map((l) => (
        <Link key={l.to} to={l.to} data-testid={`nav-${l.to.replace("/", "") || "home"}-link`}
          className={`font-body font-semibold text-sm transition-colors hover:text-emeraude ${pathname === l.to ? "text-emeraude" : "text-ink"}`}>
          {l.label}
        </Link>
      ))}
    </nav>
  );
}
